<template>
  <div>
    <div>
			<span class="xbed-sub-title">业主报表文件</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>报表</BreadcrumbItem>
				<BreadcrumbItem>业主报表文件</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label="业主" prop="owner" :label-width="90">
        <Input v-model.trim="query.owner" style="width:200px;" placeholder="业主/手机号"></Input>
      </FormItem>
      <FormItem label="文件展示名" prop="fileName" :label-width="90">
        <Input v-model.trim="query.fileName" style="width:250px;"></Input>
      </FormItem>
      <FormItem label="文件状态" prop="fileStatus" :label-width="90">
        <Select v-model="query.fileStatus" style="width:200px;">
          <Option value="S00">全部</Option>
          <Option :value="1">有效</Option>
          <Option :value="2">无效</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="queryKeyWord">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click='uploadButton'>上传文件</Button>
      </FormItem>
    </Form>
    <Content>
      <Table :columns="columns" :data="dataList" :loading='tableLoading' style="width:1555px;"></Table>
      <div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :current="query.page" :total="listTotal" :page-size="query.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
			</div>
    </Content>
    <!-- 上传文件弹窗 -->
    <Modal v-model="uploadModel.display" ref='uploadModel' title="上传文件" :loading="true" width='600'>
      <Form @submit.native.prevent="preventSubmit" :model="uploadModel" ref='uploadFrom' :rules='uploadRules' inline>
        <FormItem label="业主手机" prop="ownerPhone" :label-width="80">
          <Input v-model="uploadModel.ownerPhone" style='width: 450px;'></Input>
        </FormItem>
        <Row>
          <FormItem label="文件" :label-width="80">
            <Upload :action="uploadModel.uploadData.action" name="file" ref="files" :format="['txt','doc','xls','docx','xlsx','jpg','png','jpeg','pdf','bmp']" :data="uploadModel.uploadData.form" :on-format-error='formatError' :before-upload="editBeforeUpload" :on-success="editUploadSuccess" :on-error="editUploadError" :show-upload-list="false" style='display:inline-block;'>
              <Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
            </Upload>
          </FormItem>
          <FormItem>
            <span style='display:inline-block;width: 330px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;'>{{uploadModel.fileName ? uploadModel.fileName : '文件.xlsx/txt/doc/xls/docx/jpg/png/jpeg/pdf/bmp'}}</span>
          </FormItem>
        </Row>
        <FormItem label="展示名" prop="shownName" :label-width="80">
          <Input v-model="uploadModel.shownName" :maxlength='30' style='width: 450px;'></Input>
        </FormItem>
        <FormItem label="文件状态" prop="selectStatus" :label-width="80">
          <Select v-model="uploadModel.selectStatus" style="width:200px;">
            <Option :value="1">有效</Option>
            <Option :value="2">无效</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
				<Button type="text" :disabled="uploadModel.importButtonLoading" @click="cancelImport">取消</Button>
				<Button type="primary" :loading="uploadModel.importButtonLoading" @click="importFile">上传</Button>
			</div>
    </Modal>
    <!-- 管理文件 -->
    <Modal v-model="manageFileModel.display" ref='manageFileModel' title="管理文件" :loading="true" @on-ok='manageFileOk'>
      <Form @submit.native.prevent="preventSubmit" :model="manageFileModel" ref='manageFileFrom' :rules='manageFileRules'>
        <FormItem label="业主" prop="ownerMsg" :label-width="80">
          <Input v-model='manageFileModel.ownerMsg' disabled></Input>
        </FormItem>
        <FormItem label="展示名" prop="mangerShowName" :label-width="80">
          <Input v-model="manageFileModel.mangerShowName" :maxlength='30'></Input>
        </FormItem>
        <FormItem label="文件状态" prop="mangerStatus" :label-width="80">
          <Select v-model="manageFileModel.mangerStatus" style="width:200px;">
            <Option :value="1">有效</Option>
            <Option :value="2">无效</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Config from "../../config"
import Utils from "../../utils";
import {phoneRegular} from "@/utils/regular.js";
import API from "../../api";

export default {
  async created() {
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.headerENV = Utils.aliHeaderEnv(this.env)
		this.analysisUrl = Config[this.env].analysisUrl;
	},
  data () {
    const validateList = {
      ownerPhone: ( rule, value, callback ) => {
				if (!phoneRegular.test(this.uploadModel.ownerPhone)) {
					callback( new Error( '请正确填写业主手机' ) )
				} else {
					callback();
				}
			},
      shownName: ( rule, value, callback ) => {
				if (!this.uploadModel.shownName) {
					callback( new Error( '展示名不允许为空' ) )
				} else {
					callback();
				}
			},
    }
    return {
      query:{
        owner:'',
        fileName:'',
        fileStatus:'S00',
        page:1,
        pageSize:10,
        id:''
      },
      downloadLoading:false,
      tableLoading:false,
      dataList:[],
      listTotal:0,
      columns:[
        {
          title:'ID',
          key:'id',
          align:'center',
          width:100
        },
        {
          title:'业主',
          key:'ownerInfo',
          align:'center',
          width:250
        },
        {
          title:'文件展示名',
          key:'fileName',
          align:'center',
          width:200
        },
        {
          title:'文件格式',
          key:'fileNameExt',
          align:'center',
          width:100
        },
        {
          title:'文件状态',
          key:'state',
          align:'center',
          width:100,
          render: (h,params)=>{
            const status = ['','有效','无效'][params.row.state]
            return h('div',{},status)
          }
        },
        {
          title:'上传信息',
          key:'uploadInfo',
          align:'center',
          width:300
        },
        {
          title:'更新信息',
          key:'updateInfo',
          align:'center',
          width:300
        },
        {
          title:'操作',
          key:'id',
          align:'center',
          width:200,
          render:(h,params) =>{
            return h('div',[
              h('Button',{
                props:{
                  size: "small",
                  type: "success"
                },
                style:{
                  margin:'3px'
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'reportFile_update' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    this.manageFileModel.id = params.row.id
                    this.manageFileModel.ownerMsg = params.row.ownerInfo
                    this.manageFileModel.mangerShowName = params.row.fileName
                    this.manageFileModel.mangerStatus = params.row.state
                    this.manageFileModel.display = true;
                  }
                }
              },'管理'),
              h('Button',{
                props:{
                  size: "small",
                  type: "primary",
                  loading: params.row.$isLoading
                },
                style:{
                  margin:'3px',
                },
                on:{
                  click:()=>{
                    if ( !Utils.hasPermission( 'reportFile_download' ) ) {
                      this.$Notice.error( {
                        title: "无权限操作"
                      } );
                      return
                    }
                    let url = `${ this.analysisUrl }reportFile/download?id=${params.row.id}`;
                    Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, '',params)
                  }
                }
              },'下载'),
            ])
          }
        },
      ],
      // 上传文件
      uploadModel:{
        display:false,
        importButtonLoading:false,
        ownerPhone:'',
        shownName:'',
        selectStatus:1,
        fileName:'',
        uploadData:{
          file:'',
          action:'',
          form:{
            fileName:'',
            state:1,
            createName:'',
            ownerPhone:''
          }
        }
      },
      uploadRules:{
        ownerPhone: [
					{required: true, validator: validateList.ownerPhone, trigger: 'blur'}
				],
        shownName: [
					{required: true, validator: validateList.shownName, trigger: 'blur'}
        ]
      },
      // 管理文件
      manageFileModel:{
        display:false,
        id:'',
        ownerMsg:'',
        mangerShowName:'',
        mangerStatus:1
      },
      manageFileRules:{
       mangerShowName:[
         {required: true,message: '展示名不允许为空'}
       ]
      }
    }
  },
  mounted() {
    this.$Notice.config( {
			top: 200
		});
    this.getListData()
  },
  methods: {
    async getListData(){
      if ( !Utils.hasPermission( 'reportFile_list' )) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      let params = {
        pageNum:this.query.page,
        pageSize:this.query.pageSize,
      }
      this.query.owner ? ( params.ownerInfo = this.query.owner )	: "";
      this.query.fileName ? ( params.fileName = this.query.fileName )	: "";
      this.query.fileStatus !='S00' ? ( params.state = this.query.fileStatus )	: "";
      this.query.id ? ( params.ownerId = this.query.id )	: "";
      this.tableLoading = true;
      const resp = (await API.omsAPI[this.env].clientServer.reportFileList(params,{'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      this.tableLoading = false;
      if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取数据失败",
					desc: resp.msg
				});
      }
      this.dataList = resp.list;
      this.listTotal = resp.total;
    },
    queryKeyWord(){
      this.query.page = 1
      this.getListData()
    },
    changePage(page){
      this.query.page = page
      this.getListData()
    },
    changePageSize(size){
      this.query.page = 1
      this.query.pageSize = size
      this.getListData()
    },
    // ============================上传文件============================
    uploadButton(){
      if ( !Utils.hasPermission( 'reportFile_insert' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
      this.uploadModel.uploadData = {
				file: null,
				action:`${ this.analysisUrl }reportFile/insert`,
				form: {createName: this.username}
			};
      this.uploadModel.fileName = ''
      this.uploadModel.ownerPhone = ''
      this.uploadModel.shownName = ''
      this.uploadModel.display = true;
    },
    formatError(){
      this.$Notice.error({
        title: '文件格式不支持'
      })
      this.uploadModel.importButtonLoading = false;
      return false;
    },
    editBeforeUpload(file){
      if (file.size == 0) {
        this.$Notice.error({
          title: '上传文件不允许为空'
        })
        return false;
      }
      if(file.size > 52428800){
        this.$Notice.error({
          title: '上传文件大小不能超过50M'
        })
        return false;
      }
      this.uploadModel.fileName = file.name;
      this.uploadModel.uploadData.file = file;
      return false;
    },
    importFile(){
      let validResult = false;
			this.$refs.uploadFrom.validate( valid => {
				validResult = valid
			} );
			if ( !validResult ) {
				this.$refs.uploadModel.buttonLoading = false;
				return false;
			}
      if(!this.uploadModel.uploadData.file){
        this.$Notice.error( {
					title: "导入失败",
					desc: "请导入文件"
        });
        this.uploadModel.importButtonLoading = false;
        return false;
      }
      this.uploadModel.importButtonLoading = true;
      this.uploadModel.uploadData.form.createName = this.username;
      this.uploadModel.uploadData.form.fileName = this.uploadModel.shownName;
      this.uploadModel.uploadData.form.state = this.uploadModel.selectStatus;
      this.uploadModel.uploadData.form.ownerPhone = this.uploadModel.ownerPhone;
      this.$refs.files.post(this.uploadModel.uploadData.file);
    },
    editUploadSuccess(resp){
      this.uploadModel.importButtonLoading = false
      if(resp.retCode != 21020000){
        this.$Notice.error({
					title: "导入失败",
					desc: resp.msg
        });
        this.uploadModel.importButtonLoading = false
        return false;
      }
      this.$Notice.success({
				title: "导入成功",
				desc: resp.msg
      });
      this.getListData()
      this.uploadModel.display = false;
    },
    editUploadError(e,error){
      this.uploadModel.importButtonLoading = false
      let msg = "请稍候再试";
			if ( error.msg ) {
				msg = error.msg;
			}
			this.$Notice.error( {
				title: "导入失败",
				desc: msg
			});
    },
    cancelImport(){
      this.uploadModel.uploadData = {
				file: null,
				action:`${ this.analysisUrl }reportFile/insert`,
				form: {createName: this.username}
			};
			this.uploadModel.fileName = ''
      this.uploadModel.display = false;
      this.$refs.uploadFrom.resetFields();
      this.uploadModel.ownerPhone = ''
      this.uploadModel.shownName = ''
    },
    // ==========================管理文件=========================
    async manageFileOk(){
      let validResult = false;
			this.$refs.manageFileFrom.validate( valid => {
				validResult = valid
			} );
			if ( !validResult ) {
				this.$refs.manageFileModel.buttonLoading = false;
				return;
      }
      let params = {
        id:this.manageFileModel.id,
        fileName:this.manageFileModel.mangerShowName,
        state:this.manageFileModel.mangerStatus,
        updateName:this.username
      }
      const resp = (await API.omsAPI[this.env].clientServer.reportFileUpdate(params,{'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if ( resp.retCode ) {
				this.$Notice.error({
					title: "更新失败",
					desc: resp.msg
				});
      }
      this.$Notice.success({
        title: "更新成功",
        desc: resp.msg
      });
      this.getListData()
      this.manageFileModel.display = false;
    },
    preventSubmit(){
      return false;
    }
  }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/report/blue-owner-report.vue